import { Stack, Typography } from '@mui/material';
import { useUpdatePersonalDetailsDictionary } from 'Hooks/useUpdatePersonalDetailsDictionary';
import { useFormContext } from 'react-hook-form';
import { useAppSelector } from 'Hooks';
import { ToggleButtons } from 'Components/HookFormInputs/ToggleButtons';
import { TextInput } from 'Components/HookFormInputs/TextInput';
import { DatePickerInput } from 'Components/HookFormInputs/DatePickerInput';
import { sanitizeLettersNumbersAndSpacialChars } from 'Utils/sanitizeLettersNumbersAndSpacialChars';
import { sanitizeNumbersLength } from 'Utils/sanitizeNumbers';
import { CustomFieldset } from 'Components';
import { defaultMinDate } from 'Config';

interface IChildForm {
  index: number;
}

export const ChildForm = ({ index }: IChildForm) => {
  const {
    register,
    formState: { errors },
    watch,
  } = useFormContext();

  const generalOptions = useAppSelector(
    (generalOptions) => generalOptions.generalOptions.generalOptions
  );

  const dictionary = useUpdatePersonalDetailsDictionary().addChild.child;

  return (
    <Stack alignItems='center' justifyContent='center'>
      <Typography alignSelf='flex-start' mb='10px'>
        {dictionary.inputLabel1}
      </Typography>
      <CustomFieldset>
        <fieldset style={{ width: '100%' }}>
          <legend>{dictionary.inputLabel1}</legend>
          <ToggleButtons
            option1={{
              id: generalOptions?.general?.genders[0]?.id || 0,
              value:
                (generalOptions?.general?.genders[0]?.value === dictionary.male
                  ? dictionary.boy
                  : dictionary.girl) || '0',
            }}
            option2={{
              id: generalOptions?.general?.genders[1]?.id || 1,
              value:
                (generalOptions?.general?.genders[1]?.value === dictionary.male
                  ? dictionary.boy
                  : dictionary.girl) || '1',
            }}
            registerName={'familyMembers.' + index + '.gender'}
          />
        </fieldset>
        <TextInput
          label={dictionary.inputLabel2}
          register={register('familyMembers.' + index + '.firstName', {
            onChange: (e) => sanitizeLettersNumbersAndSpacialChars(e, 20),
          })}
          errors={(errors as any)?.familyMembers?.[index]?.firstName}
          shrink={
            (watch('familyMembers.' + index + '.firstName') || '')?.length > 0
          }
        />
        <TextInput
          label={dictionary.inputLabel3}
          register={register('familyMembers.' + index + '.lastName', {
            onChange: (e) => sanitizeLettersNumbersAndSpacialChars(e, 40),
          })}
          errors={(errors as any)?.familyMembers?.[index]?.lastName}
          shrink={
            (watch('familyMembers.' + index + '.lastName') || '')?.length > 0
          }
        />
        <DatePickerInput
          label={dictionary.inputLabel4}
          maxDate={new Date(Date.now())}
          registerName={'familyMembers.' + index + '.birthDate'}
          maxWidth='400px'
          minDate={defaultMinDate}
        />
        <TextInput
          label={dictionary.inputLabel5}
          register={register('familyMembers.' + index + '.identityNumber', {
            onChange: (e) => sanitizeNumbersLength(e, 9),
          })}
          errors={(errors as any)?.familyMembers?.[index]?.identityNumber}
          shrink={
            (watch('familyMembers.' + index + '.identityNumber') || '')
              ?.length > 0
          }
          isNumbersOnly={true}
        />
      </CustomFieldset>
    </Stack>
  );
};
